'use strict';

import {isDev, settingsData, threeJsVariables} from "../../settings";
import {getUrlParam} from "../../functions";
import * as dat from "dat.gui";

/**
 * GUI - helper for visual options for object on Scene
 * Works only in development mode
 */

export const addGui = () => {
    if (!isDev) return;

    console.log('GUI Development mode activated');

    threeJsVariables.gui = new dat.GUI();
    threeJsVariables.gui.close();

    // threeJsVariables.gui = gui;
}